import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import VueAxios from 'vue-axios'
import axios from 'axios'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import App from './App'
import router from './router'
import store from './store'
import i18n from './i18n'

library.add(fab)
library.add(fas)

Vue.filter('fixNumber', function (value, decimal = 2) {
  return (!value && isNaN(Number(value))) ? '' : Number(value).toFixed(decimal)
})

Vue.component('font-awesome-icon', FontAwesomeIcon)

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_BASE,
  headers: { 'Content-Type': 'application/json' }
})

Vue.use(BootstrapVue)
Vue.use(VueAxios, axiosInstance)

axiosInstance.interceptors.request.use((config) => {
  const doctor = store.state.doctor
  if (doctor) {
    config.headers.Authorization = `Bearer ${doctor.jwt}`
  }
  return config
})

Vue.config.productionTip = false

new Vue({
  router: router,
  store: store,
  i18n,
  render: h => h(App)
}).$mount('#app')
